
import BaseImage from '@/ui-kit/components/image';
import ImageCommonProps from '@/ui-kit/components/image/mixins/ImageCommonProps';
import NOT_FOUND_IMAGE_SRC from './constants';

export default {
  name: 'ListingImage',
  components: {
    BaseImage,
  },
  mixins: [
    ImageCommonProps,
  ],
  data() {
    return {
      NOT_FOUND_IMAGE_SRC: NOT_FOUND_IMAGE_SRC.LISTING,
    };
  },
};
